<template>
  <v-container>
    <v-row
      v-for="(summaryNote, i) in summaryNotes"
      :key="i">
      <v-col cols="12">
        <v-row class="mx-3 my-3">
          <v-col>
            <span class="title">วันที่สร้าง</span>
            <span>{{ summaryNote.createdAt | dateTimeUserFormat() }}</span>
          </v-col>
          <v-col>
            <span class="title">เลขที่ใบนำเข้า</span>
            <span>{{ noteCode }}</span>
          </v-col>
          <v-col>
            <span class="title">จำนวนสินค้า</span>
            <span>{{ summaryNote.productTotal }} แบบ</span>
          </v-col>
          <v-col>
            <span class="title">จำนวนชิ้น</span>
            <span>{{ summaryNote.skuTotal }} ชิ้น</span>
          </v-col>
        </v-row>
        <v-row class="mx-3 my-3">
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th></th>
                    <th>นับได้/ทั้งหมด</th>
                    <th>เลขที่ใบนำออก</th>
                    <th>เลขที่ใบนำเข้า</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(w, index) in summaryNote.toWarehouses"
                    :key="index">
                    <td>{{ w.warehouse.name }}</td>
                    <td
                      :class="w.skuCount === w.skuAmount && w.skuAmount === w.skuCountIsComplete ? 'green--text' : 'red--text'"
                      class="text-center">
                      {{ w.skuCount }} / {{ w.skuAmount }}
                    </td>
                    <td>
                      <a @click="goToNote(w.withdrawNote, 'WithdrawNote')">{{ avoidNullValue(w.withdrawNote, 'code') }}</a>
                      <span :class="`${getStatusColor(w.withdrawNote.status)} text-uppercase ml-3`">
                        {{ w.withdrawNote.status }}
                      </span>
                      <v-btn
                        v-if="w.withdrawNote.status === 'pending' && w.skuCount === w.skuAmount && w.skuAmount === w.skuCountIsComplete"
                        x-small
                        class="ml-2"
                        @click="openDialogApprove(w, summaryNote.fromWarehouse)">
                        APPROVE
                      </v-btn>
                    </td>
                    <td>
                      <template v-if="w.deliveryNote && w.deliveryNote.id">
                        <a @click="goToNote(w.deliveryNote, 'DeliveryNote')">{{ avoidNullValue(w.deliveryNote, 'code') }}</a>
                        <span :class="`${getStatusColor(w.deliveryNote.status)} text-uppercase ml-3`">
                          {{ w.deliveryNote.status }}
                        </span>
                      </template>
                      <span
                        v-else
                        class="grey--text">
                        จะสร้างหลัง Approve ใบนำออก
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-if="dialogApprove"
      v-model="dialogApprove"
      persistent
      max-width="600">
      <v-card class="pa-5">
        <v-card-title class="headline">
          <label>Approve {{ approveInfo.withdrawNote.code }}</label>
        </v-card-title>
        <v-card-text>
          <p class="mt-2 mb-2">
            <span class="font-weight-bold">เลขที่</span> {{ approveInfo.withdrawNote.code }}
          </p>
          <div class="mb-2">
            <span class="mr-2 font-weight-bold">Location</span>
            <v-chip
              color="indigo"
              dark
              small>
              {{ approveInfo.fromWarehouse.name || '' }}
            </v-chip>
            <v-icon>
              mdi-arrow-right-bold
            </v-icon>
            <v-chip
              color="success"
              dark
              small>
              {{ approveInfo.warehouse.name }}
            </v-chip>
          </div>
          <p class="mb-0">
            ต้องการ Approve ใช่หรือไม่
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loadingApprove"
            @click="closeDialogApprove()">
            CANCEL
          </v-btn>
          <v-btn
            color="secondary"
            :loading="loadingApprove"
            @click="onApprove('approve')">
            APPROVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import InventoryProvider from '@/resources/InventoryProvider'

const InventoryService = new InventoryProvider()

export default {
  props: {
    noteCode: {
      type: String,
      default: ''
    },
    summaryNotes: {
      type: Array,
      default: () => []
    },
    onApprovedWn: {
      type: Function,
      default: () => null
    }
  },
  data () {
    return {
      total: {
        product: 0,
        amount: 0
      },
      branches: [],
      approveInfo: null,
      dialogApprove: false,
      loadingApprove: false
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar'
    }),
    avoidNullValue (object, properties, defaultValue = '-') {
      return object[properties] || defaultValue
    },
    getStatusColor (status) {
      switch (status) {
        case 'pending': return 'status-text-pending'
        case 'approved': return 'status-text-approved'
        case 'canceled': return 'status-text-canceled'
        case 'draft': return 'status-text-draft'
        default: return ''
      }
    },
    async goToNote (note, name) {
      try {
        window.open(this.$router.resolve({
          name,
          query: { id: note.id, warehouse: note.warehouseId }
        }).href, '_blank')
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      }
    },
    openDialogApprove (noteInfo, fromWarehouse) {
      this.approveInfo = { ...noteInfo, fromWarehouse }
      this.dialogApprove = true
    },
    async onApprove (status) {
      this.loadingApprove = true
      try {
        await InventoryService.updateStatusWithdrawNotes({
          id: this.approveInfo.withdrawNote.id,
          status
        }, {
          warehouse: this.approveInfo.fromWarehouse,
          products: this.approveInfo.withdrawNote.products
        })
        this.onApprovedWn(this.approveInfo.withdrawNote.id)
        this.setSnackbar({
          value: true,
          message: `approved : ${ this.approveInfo.withdrawNote.code }`,
          type: 'success'
        })
      } catch (error) {
        console.error('updateStatusNote', error)
        this.setSnackbar({
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.closeDialogApprove()
      }
    },
    closeDialogApprove () {
      this.loadingApprove = false
      this.dialogApprove = false
      this.approveInfo = null
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 600;
  padding-right: 5px;
}
.status-text-pending {
  color: #EF5350;
}
.status-text-approved {
  color: #40a145;
}
.status-text-canceled {
  color: #363636;
}
.status-text-draft {
  color: #cacaca;
}
</style>
